import useRoleAuthentication from "../../../Authentication/hooks/useRoleAuthentication";
import { menuItemsEnum } from "./menuItemsEnum";
import { useGetApplicationDetailsQueryState } from "../../../services/graphql/api";
import { getApplDetailParams } from "../../../util/functions";
import { STUDENT_REQUEST_ACTIONS } from "../../../util/constants";

const useActionMenuItems = () => {
    const { data, error, isFetching } = useGetApplicationDetailsQueryState(getApplDetailParams()); // eslint-disable-line
    const status = data?.status ?? {};
    const details = data?.details ?? {};
    const configuration = data?.configuration ?? {};
    const { roles } = useRoleAuthentication();
    if (isFetching || error) { return {}; } // Empty menu
    const extraInfo = {
        assignable: status.assignable,
        isInProgress: !status.isApplicationReviewed, // TODO Validate this is all we need.. may need to check for status=cancelled
        isOverrideable: status.isApplicationOverrideable, // TODO Validate this is all we need.. may need to check for status=cancelled
        isAssignedReviewer: status.isAssignedReviewer,
        hasUnassignableReviewers: configuration.unassignableReviewers?.length > 0,
        priority: status.priority,
        isApplicationFinalized: status.isApplicationFinalized,
        isApplicationCancelled: status.isApplicationCancelled,
        canAdminOverride: status.canAdminOverride,
        appealRequested: details.administratorDetails?.studentRequestType === STUDENT_REQUEST_ACTIONS.APPEAL.label,
        withdrawRequested: details.administratorDetails?.studentRequestType === STUDENT_REQUEST_ACTIONS.WITHDRAW.label,
        programChangeRequested: details.administratorDetails?.studentRequestType === STUDENT_REQUEST_ACTIONS.PROGRAM_CHANGE.label,
        studentRequestIsActive: details.administratorDetails?.studentRequestIsActive,
    };

    const menuItems = menuItemsEnum.filter(menuItem => {
        if (menuItem.disabled) { return false; } // Feature flag for removing menu items
        
        const rolesAllowed = menuItem.roles ?? [];
        const hasRole = rolesAllowed.some(role => roles?.includes(role));
        if (!hasRole) { return false; } // Exclude menu item

        // Check all the special exclusion cases
        const filterFns = menuItem.specialCaseFilterFns ?? [];
        return filterFns.every(fn => fn(extraInfo));
    });

    return { menuItems };
}

export default useActionMenuItems;
